//LOADING
export const SET_LOADING = "SET_LOADING";

//WORD
export const SET_TARGET_WORD = "SET_TARGET_WORD";
export const SET_GUESSED_LETTER = "SET_GUESSED_LETTER";
export const CLEAR_GUESSED_WORD = "CLEAR_GUESSED_WORD";
export const CLEAR_PREVIOUS_GUESSED_WORDS = "CLEAR_PREVIOUS_GUESSED_WORDS";
export const SET_CORRECT_ANSWER = "SET_CORRECT_ANSWER";
export const ADD_GUESSED_WORD = "ADD_GUESSED_WORD";
export const SET_NEXT_LETTER = "SET_NEXT_LETTER";
export const REMOVE_LAST_LETTER = "REMOVE_LAST_LETTER";
export const SUBMIT_WORD = "SUBMIT_WORD";
